angular.module('tct.priceEntriesService', ['tct.configService'])
  .factory('priceEntriesService', priceEntriesService);

priceEntriesService.$inject = [
  'configService', '$http',
];

function priceEntriesService(configService, $http) {
  const basePath = `${configService.APP_PROTOCOL}://${configService.APP_API}:${configService.APP_API_PORT}/api/price-lists`;
  const factory = {
    getPriceListForItalianCompany,
    getPriceListForForeignCompany,
    getDefaultPriceList,
  };

  return factory;

  function getPriceListForItalianCompany(searchEntry) {
    return $http.get(`${basePath}/companies/by-rea`, {
      params: {
        rea_number: searchEntry.rea_number,
        cciaa: searchEntry.cciaa.code,
      },
    });
  }

  function getPriceListForForeignCompany(searchEntry, countryCode) {
    return $http.get(`${basePath}/companies/foreign`, {
      params: {
        country: countryCode,
        duns: searchEntry.duns,
        registration_number: searchEntry.registration_number,
      },
    });
  }

  function getDefaultPriceList() {
    return $http.get(`${basePath}/default`);
  }
}
